import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CircularProgress, styled } from '@mui/material';
import { AxiosError } from 'axios';
import Header from '../../../../customs/Header';
import SettingsModal from '../Modal/settingsCustomModal';
import apiCall from '../../../../utils/apiCall';
import CreateSpecialization from './CreateSpecialization';
import SpecializationContent from './SpecializationContent';

interface SpecializationResponse {
  StatusCode: number;
  Message: string;
  Data: Specialization[];
}

interface Specialization {
  Id: number;
  SpecializationName: string;
  Score: number;
  IsActive: boolean;
  CreatedBy?: string;
  ModifiedBy?: string;
  CreateDate: string;
  LastModified: string;
  IsDeleted: boolean;
}

export default function Specialization () {
  const [openCreateSpecializationModal, setOpenCreateSpecializationModal] = useState(false);

  const handleOpenCreateSpecializationModal = () => setOpenCreateSpecializationModal(true);
  const handleCloseCreateSpecializationModal = () => setOpenCreateSpecializationModal(false);
  
  const getAllSpecialization = async(): Promise<SpecializationResponse> => {
    return (await apiCall().get('/SetUp/GetAllSpecialization')).data
  };

  const { data, isLoading, isError, error } = useQuery(['get-specializations'], getAllSpecialization, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });

  const specializationError = error as AxiosError;
  const specializationErrorMessage = specializationError?.message;

  return (
    <section>
      <Header props={
        { 
          firstName: 'All', 
          secondName: 'Specialization', 
          buttonText: 'Create Specialization'
        }}
        handleOpen={handleOpenCreateSpecializationModal}
      />
      {isLoading ? (
        <CircularProgress 
          sx={{
            fontSize: '1rem',
            marginInline: 'auto',
            display: 'block',
            marginBlock: '2rem'
          }}
        />
      ) : isError ? (
        <StyledError>{specializationErrorMessage}</StyledError>
      ) : (
        <SpecializationContent specialization={data}/>
      )}

      <SettingsModal 
        open={openCreateSpecializationModal}
        cancel={handleCloseCreateSpecializationModal}
        maxWidth='480px'
        header='Create Specialization'
        showrightIcon={false}
        content={<CreateSpecialization
          handleClose={handleCloseCreateSpecializationModal} 
        />}      
      />
    </section>
  )
}

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`